import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
  tableStyle: {
    border: "none",
    boxShadow: "none",
  },
  tableText: {
    fontFamily: "Open Sans",
    fontWeight: 'normal',
    fontSize: "12px",
    lineHeight: "16px",
    color: "#141414",
    textAlign: "center",
    margin: "10px",
    padding: "6px",
    minWidth: "120px"
  },
  tableHeader: {
    textAlign: "center",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    color: '#6F6F6F',
    fontSize: "14px",
    lineHeight: "19px",
    padding: "6px",
  },
  even: {
    background: "#F3F3F3",
  },
  odd: {
    background: "#FFFFFF",
  },
}));

function ActivityIndicatorsTable(props) {
  const classes = useStyles();
  useTheme();

  const getClass = (rowIndex) => {
    if (rowIndex % 2 === 0) {
      return classes.even;
    }

    return classes.odd;
  };

  const { activity_indicators } = props;

  const rows = [];
  if (activity_indicators.employees_range != null) {
    rows.push({ label: "Faixa de Funcionários", value: String(activity_indicators.employees_range) });
  }
  if (activity_indicators.income_range != null) {
    rows.push({ label: "Faixa de Faturamento", value: String(activity_indicators.income_range) });
  }
  if (activity_indicators.activity_level != null) {
    rows.push({ label: "Nível de Atividade", value: (activity_indicators.activity_level * 100).toFixed(0) + "%" });
  }
  if (activity_indicators.has_active_domain != null) {
    rows.push({ label: "Domínio Ativo", value: activity_indicators.has_active_domain === true ? 'Sim' : activity_indicators.has_active_domain === false ? 'Não' : "-" });
  }
  if (activity_indicators.has_corporate_email != null) {
    rows.push({ label: "E-mail Corporativo", value: activity_indicators.has_corporate_email === true ? 'Sim' : activity_indicators.has_corporate_email === false ? 'Não' : "-" });
  }
  if (activity_indicators.shell_company_likelyhood != null) {
    rows.push({ label: "Probabilidade de Empresa de Fachada", value: (activity_indicators.shell_company_likelyhood * 100).toFixed(0) + "%" });
  }

  return (
    <Paper className={classes.tableStyle}>
      <Table style={{ padding: "8px" }}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHeader}>Campo</TableCell>
            <TableCell className={classes.tableHeader}>Valor</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow
              key={index}
              className={getClass(index)}
            >
              <TableCell style={{whiteSpace:"nowrap"}} className={classes.tableText}>
                {row.label}
              </TableCell>
              <TableCell className={classes.tableText}>
                {row.value}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

export default ActivityIndicatorsTable;
